/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useMemo } from "react";

export const useFilterAllowedProviders = (selectedServices, anyUnit) => {
  const filterAllowedProviders = useMemo(
    () => (providers) => {
      const groupCount = selectedServices?.find((service) => service.group_booking_count)?.group_booking_count || 1;

      let result = [
        ...providers.map((provider) => {
          const servesSelectedServices = selectedServices
            ? selectedServices.every(
                (service) => provider.services?.some((serviceId) => +serviceId === +service.id)
              )
            : true;
          const hasGroupCapacity = groupCount <= 1 || +provider.qty >= groupCount;

          return { ...provider, is_available: servesSelectedServices && hasGroupCapacity };
        }),
      ];

      if (anyUnit) {
        result.unshift({ ...anyUnit, is_available: true });
      }

      return result;
    },
    [anyUnit, selectedServices]
  );

  return filterAllowedProviders;
};
